import React, { Component } from 'react';
import axios from "axios";
import "react-inputs-validation/lib/react-inputs-validation.min.css";

import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';

export class DemoRequestForm extends Component {
    constructor(props) {    
        super(props);    
        this.state = {    
            schoolname: "",
            board:"",
            state:"",
            district:"",
            schoolweb:"",
            count:"",
            contact:"",
            designation:"",
            mobile:"",
            email:"",
            date:"",
            Itgk_code:"",
            Itgk_name:"",
            address:"",  
            preferred_date_time:"",  
            address:"",
            user_captcha_input:"",
        formErrors: {}    
        };    
    
        this.initialState = this.state;    
    }  
  allLetter(inputtxt)
  {
   var letters = /^[A-Za-z]+$/;
   if(inputtxt.value.match(letters))
     {
      return true;
     }
   else
     {
    //alert("message");
     return false;
     }
  }
  onKeyPress1 = (e) => {
  //onKeyPress1(e){
    const { name, value } = e.target; 
    let formErrors = {};    
    //let formIsValid = true;    
    this.setState({ [name]: value });
    if(!(/^[A-Za-z ]+$/.test(value) ) ){
    // formIsValid = false;
         formErrors["schoolNameErr"] = "School name must be valid.";
    }else{
        this.setState({ [name]: value }); 
    }
  }
      handleFormValidation() {    
        const { schoolname, board,
        state,
        district,
        schoolweb,
        count,
        contact,
        designation,
        mobile,
        email,
        preferred_date_time,
        Itgk_code,
        Itgk_name,
        address, } = this.state;    
        let formErrors = {};    
        let formIsValid = true;    
      
        //Student name     
        if (!schoolname) {    
            formIsValid = false;    
            formErrors["schoolNameErr"] = "Please Enter School Name.";    
        } else if( !(/^[A-Za-z ]+$/.test(schoolname) ) ){
            formIsValid = false; 
            formErrors["schoolNameErr"] = "School Name Must be Valid.";
        }
        //Email    
        if (!email) {    
            formIsValid = false;    
            formErrors["emailErr"] = "Please Enter Email id.";    
        }    
        else if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))) {    
    
            formIsValid = false;    
            formErrors["emailErr"] = "Please Enter Invalid Email id.";    
        }    
        
        //DOB    
        /*if (!preferred_date_time) {    
            formIsValid = false;    
            formErrors["dateErr"] = "Please Enter Preferred Date.";    
        }    
        else {    
            var pattern = /^(0[1-9]|1[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/([0-9]{4})$/;    
            if (!pattern.test(dob)) {    
                formIsValid = false;    
                formErrors["dobErr"] = "Invalid date of birth";    
            }    
        }*/
        if (!board) {    
            formIsValid = false;    
            formErrors["boardErr"] = "Please Enter Board.";    
        }
        if (!state) {    
            formIsValid = false;    
            formErrors["stateErr"] = "Please Enter State Name.";    
        }
        if (!district) {    
            formIsValid = false;    
            formErrors["districtErr"] = "Please Enter District.";    
        }
        // if (!schoolweb) {    
        //     formIsValid = false;    
        //     formErrors["schoolWebErr"] = "School Web.";    
        // }
        if (!count) {    
            formIsValid = false;    
            formErrors["countErr"] = "Please Enter Student Count.";    
        }
        if (!contact) {    
            formIsValid = false;    
            formErrors["contactErr"] = "Please Enter Contact Person.";    
        }
        if (!designation) {    
            formIsValid = false;    
            formErrors["designationErr"] = "Please Enter Designation.";    
        }
        
        if (!mobile) {    
            formIsValid = false;    
            formErrors["mobileErr"] = "Please Enter Mobile Number.";    
        }    
        else {    
            var mobPattern = /^(?:(?:\\+|0{0,2})91(\s*[\\-]\s*)?|[0]?)?[789]\d{9}$/;    
            if (!mobPattern.test(mobile)) {    
                formIsValid = false;    
                formErrors["mobileErr"] = "Please Enter Valid Mobile Number.";    
            }    
        }
        /*if (!Itgk_code) {    
            formIsValid = false;    
            formErrors["Itgk_codeErr"] = "Please Enter Itgk Code.";    
        }if (!Itgk_name) {    
            formIsValid = false;    
            formErrors["Itgk_nameErr"] = "Please Enter Itgk Name.";    
        }*/
        if (!address) {    
            formIsValid = false;    
            formErrors["addressErr"] = "Please Enter Address.";    
        }
        /*if (!mobile) {    
            formIsValid = false;    
            formErrors["mobileErr"] = "Mobile.";    
        }*/
        let user_captcha_value = document.getElementById('user_captcha_input').value;
        if (!user_captcha_value) {    
            formIsValid = false;    
            formErrors["captchaErr"] = "Please Enter Captcha.";    
        }else if (validateCaptcha(user_captcha_value)===true) { 
        }else{  
            formIsValid = false;    
            formErrors["captchaErr"] = "Please Enter Valid Captcha.";
        }
        this.setState({ formErrors: formErrors });    
        return formIsValid;    
      }
    checkCharcterOnly = (e) => { 
        const { name, value } = e.target; 
        if((/^[A-Za-z ]+$/.test(value) ) ){
            this.setState({ [name]: value }); 
            }
    }  
    checkNumberOnly = (e) => {   
        const { name, value } = e.target; 
        if((/^[0-9]+$/.test(value) ) ){
            this.setState({ [name]: value });
        }
    }
    handleChange = (e) => { 
        const { name, value } = e.target;    
        this.setState({ [name]: value });    
    }  
    handleSubmit = (e) => {    
        e.preventDefault();    
    
        if (this.handleFormValidation()) {    
            //alert('You have been successfully registered.')    
            //this.setState(this.initialState);
            this.addStudent();
            console.log(this.initialState);
        }    
    }
    
    addStudent = () => {
        axios
          .post(
           // "http://10.1.1.214/erp/public/api/demo_request",
            "https://schooleasyerp.com/webservices/sendEnquiry.php",
            //"http://localhost/webservices/sendEnquiry.php",
            this.state
          )
          .then((response) => {
            if (response.status === 200) {
                console.log(response);
               this.setState(this.initialState);
                alert(response.data.message);  
            }
          });
      };

      componentDidMount() {
        //this.getDemoRequestData();
        loadCaptchaEnginge(6); 
      } 

render() { 
    const { schoolNameErr, mobileErr, designationErr, contactNameErr, countErr, districtErr, stateErr, boardErr, emailErr, dateErr, Itgk_codeErr, Itgk_nameErr, addressErr,contactErr,captchaErr } = this.state.formErrors;
return (
<div>
<div className="request_demo" id="request_demo">
<div className="container">
<div className="row py-4">
<form onSubmit={this.handleSubmit}>
    <h6>Request A Demo</h6>
    <div class="row">
            <div className="col-md-4">
                <div className="form-outline1">
                <label for="validationCustom01" className="form-label">School Name<span className='star'>*</span></label>
                    <input
                        name="schoolname"
                        type="text"
                        className="form-control"
                        id="validationCustom01"
                        //onKeyPress={event =>this.onKeyPress1(event)}
                        onChange={event=> this.checkCharcterOnly(event)}
                       value={this.state.schoolname} 
                       maxlength="35"
                       onkeypress="javascript:return allowchar(event);"
                    />
                    {schoolNameErr &&    
                     <div style={{ color: "red", paddingBottom: 10 }}>{schoolNameErr}</div>    
                            }
                </div>
            </div>
            <div className="col-md-4">
            <label for="validationCustom03" className="form-label">Board<span className='star'>*</span></label>
                <select name="board" id="board"
                 value={this.state.board}
                onChange={event=> this.handleChange(event)}
                    className="select form-select"
                    data-mdb-filter="true">
                    <option value="1" selected>Select Board</option>
                    <option value="2">RBSC Board</option>
                    <option value="3">CSC Board</option>
                    <option value="4">ISC Board</option>
                    <option value="5">Other State Board</option>
                </select>
                {boardErr &&    
                     <div style={{ color: "red", paddingBottom: 10 }}>{boardErr}</div>    
                            }
            </div>
            
            <div className="col-md-4">
                <div className="form-outline1">
                <label for="validationCustom02" className="form-label">State<span className='star'>*</span></label>
                    <input
                    name="state"
                        type="text"
                        className="form-control"
                        id="validationCustom02"
                        value={this.state.state}
                        onChange={event=> this.checkCharcterOnly(event)}
                        maxlength="35"
                    />
                    {stateErr &&    
                     <div style={{ color: "red", paddingBottom: 10 }}>{stateErr}</div>    
                            }
                </div>
            </div>
            </div><div class="row">
            <div className="col-md-4">
                <div className="form-outline1">
                <label for="validationCustom03" className="form-label">District<span className='star'>*</span></label>
                    <input
                    name="district"
                        type="text"
                        className="form-control"
                        id="validationCustom03"
                         value={this.state.district}
                        onChange={event=> this.checkCharcterOnly(event)}
                        maxlength="35"
                    />
                    {districtErr &&    
                     <div style={{ color: "red", paddingBottom: 10 }}>{districtErr}</div>    
                            }
                </div>
            </div>
            <div className="col-md-4">
            <label for="" className="form-label">School Website (IF ANY)</label>
                <div className="form-outline1">
                    <input
                    name="schoolweb"
                    id="schoolweb"
                    type="url"
                    className="form-control"
                    value={this.state.schoolweb}
                    onChange={event=> this.handleChange(event)}
                    maxlength="35"
                    />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-outline1">
                <label for="validationCustom04" className="form-label">Total Student Count <span className='star'>*</span></label>
                    <input
                    name="count"
                    id="count"
                        type="text"
                        className="form-control" 
                        
                         value={this.state.count}
                    onChange={event=> this.checkNumberOnly(event)}
                    maxlength="10"
                    />
                   {countErr &&    
                     <div style={{ color: "red", paddingBottom: 10 }}>{countErr}</div>    
                            } 
                </div>
            </div>
            </div><div class="row">
            <div className="col-md-4">
                <div className="form-outline1">
                <label for="validationCustom05" className="form-label">Contact Person Name<span className='star'>*</span></label>
                    <input
                    name="contact"
                        type="text"
                        className="form-control"
                        id="contact"
                         value={this.state.contact}
                        onChange={event=> this.checkCharcterOnly(event)}
                        maxlength="35"
                    />
                 {contactErr &&    
                     <div style={{ color: "red", paddingBottom: 10 }}>{contactErr}</div>    
                            }   
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-outline1">
                <label for="validationCustom06" className="form-label">Contact Person Designation<span className='star'>*</span></label>
                    <input
                        name="designation"
                        type="text"
                        className="form-control"
                        id="designation"
                         value={this.state.designation}
                        onChange={event=> this.checkCharcterOnly(event)}
                        maxlength="35"
                    />
                  {designationErr &&    
                     <div style={{ color: "red", paddingBottom: 10 }}>{designationErr}</div>    
                            }  
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-outline1">
                <label for="validationCustom07" className="form-label">Contact Mobile Number<span className='star'>*</span></label>
                    <input
                    name="mobile"
                        type="text" 
                        id="mobile" 
                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="10"
                        className="form-control"
                        
                         value={this.state.mobile}
                        onChange={event=> this.checkNumberOnly(event)}
                        aria-describedby="inputGroupPrepend"
                        maxLength="10"
                    />
                   {mobileErr &&    
                     <div style={{ color: "red", paddingBottom: 10 }}>{mobileErr}</div>    
                            } 
                </div>
            </div>
            </div><div class="row">
            <div className="col-md-4">
                <div className="form-outline1">
                <label for="validationCustom08" className="form-label">Contact Email ID<span className='star'>*</span></label>
                    <input
                        name="email"
                        type="text"
                        className="form-control"
                        id="email"
                         value={this.state.email}
                        onChange={event=> this.handleChange(event)}
                        maxlength="35"
                    />
                    {emailErr &&    
                     <div style={{ color: "red", paddingBottom: 10 }}>{emailErr}</div>    
                            }
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-outline1" id="datetimepicker-dateOptions">
                <label for="datetimepickerdateOptions" className="form-label">
                    Preferred Date & Time for Demo</label>
                    <input 
                    name="preferred_date_time"
                    type="datetime-local" 
                    className="form-control" 
                    id="datetimepickerdateOptions"
                     value={this.state.preferred_date_time}
                        onChange={event=> this.handleChange(event)} />
                    
                </div>
                {dateErr &&    
                     <div style={{ color: "red", paddingBottom: 10 }}>{dateErr}</div>    
                            }
            </div>
            <div className="col-md-4">
                <div className="form-outline1">
                <label for="validationCustom08" className="form-label">Referred by RKCL ITGK Code</label>
                    <input
                    name="Itgk_code"
                        type="text"
                        className="form-control"
                        id="Itgk_code"
                        value={this.state.Itgk_code}
                        onChange={event=> this.checkNumberOnly(event)}
                        maxlength="8"
                    />
                    {Itgk_codeErr &&    
                     <div style={{ color: "red", paddingBottom: 10 }}>{Itgk_codeErr}</div>    
                    } 
                </div>
            </div>
            </div><div class="row">
            <div className="col-md-4">
                <div className="form-outline1">
                <label for="validationCustom09" className="form-label">Referred by RKCL ITGK Name</label>
                    <input
                        name="Itgk_name"
                        type="text"
                        className="form-control"
                        id="Itgk_name"
                         value={this.state.Itgk_name}
                        onChange={event=> this.checkCharcterOnly(event)}
                        maxlength="35"
                    />
                    {Itgk_nameErr &&    
                     <div style={{ color: "red", paddingBottom: 10 }}>{Itgk_nameErr}</div>    
                            }
                </div>
            </div>

            <div className="col-md-4">
                <div className="form-outline1">
                <label for="validationCustom10" className="form-label">Address<span className='star'>*</span></label>
                    <textarea name="address" 
                     value={this.state.address}
                        onChange={event=> this.handleChange(event)} 
                        className="form-control" id="address" 
                        rows="" ></textarea>
                        {addressErr &&    
                     <div style={{ color: "red", paddingBottom: 10 }}>{addressErr}</div>    
                            }
                </div>
            </div>
        
        <div className="col-md-2">
        <label for="validationCustom10" className="form-label"></label>
        <input className="form-control"  placeholder="Enter Captcha" 
        id="user_captcha_input" 
        name="user_captcha_input" 
        type="text"
        value={this.state.user_captcha_input}
        onChange={event=> this.handleChange(event)}
        maxlength="6" 
        />{captchaErr &&    
            <div style={{ color: "red", paddingBottom: 10 }}>{captchaErr}</div>    
                   }
        </div><div className="col-md-2"><div className="form-outline1">
            <LoadCanvasTemplate />
         </div>
         </div>
         </div><div class="row">
        <div className="col-md-4 align-self-center text-center">
        <input type="submit" className="btn btn-success" value="Submit"/>
        </div>
        </div>
    </form>
</div>
</div>
</div>
</div>
        )
    }
}

export default DemoRequestForm
